<table mat-table [dataSource]="dataSource" class="mat-elevation-z1 nested-table">

    <ng-container *ngFor="let column of columnChild" [matColumnDef]="column.field">
        <th mat-header-cell *matHeaderCellDef>{{ column.title }}</th>
        <td mat-cell *matCellDef="let dataItem; let rowIndex = index">
            <ng-container>
                <div class="customer-name" *ngIf="column.field == '$'">{{ rowIndex+1 }}</div>
                <a [routerLink]="['/contact', dataItem['contactID']]" target="_blank"> <div class="customer-name" *ngIf="column.field == 'lastFirst'">{{ !dataItem[column.field] ? '--' : dataItem[column.field]}}</div></a>
                <div class="customer-name" *ngIf="column.field == 'mobile'">{{ !dataItem[column.field] ? '--' : localService.maskNumbersInString(dataItem[column.field], user)}}</div>
                <div class="customer-name" *ngIf="column.field == 'email'">{{ !dataItem[column.field] ? '--' : dataItem[column.field]}}</div>
                <div class="customer-name" *ngIf="column.field == 'companyName'">{{ !dataItem[column.field] ? '--' : dataItem[column.field]}}</div>
                <div class="customer-name" *ngIf="column.field == 'contactID'">{{user.firstName }}&nbsp;{{user.lastName}}</div>
                <div class="customer-name" *ngIf="column.field == 'dtCreated'">{{ !dataItem[column.field] ? '--' : dataItem[column.field] | date:dateFormat}}</div>
            </ng-container>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

</table>

<mat-paginator *ngIf="subItems?.length > 0"
               [length]="subItems?.length" [pageSize]="10"
               [pageSizeOptions]="[10, 50, 100, 200]">
</mat-paginator>
